/****************************************************************************************************/
/* Module Imports */
/****************************************************************************************************/

//require("./mobile-menu.js");
require('jquery-lazy');
//require('jquery-backstretch');
//require('jquery-hoverintent');
require("waypoints/lib/jquery.waypoints.js");
require("waypoints/lib/shortcuts/sticky.js");
require("jquery-ui/ui/unique-id.js");
require("jquery-ui/ui/focusable.js");
require("jquery-ui/ui/tabbable");
require("jquery-ui/ui/scroll-parent.js");
//require("page-scroll-to-id/jquery.malihu.PageScroll2id.js");

var popup = require("jquery-popup-overlay");
import { Splide } from '@splidejs/splide';
//import { Grid } from '@splidejs/splide-extension-grid';

require('@splidejs/splide/dist/css/splide.min.css');
require('@splidejs/splide/dist/css/themes/splide-default.min.css');
window.Splide = Splide; // make splide available to widget scripts

/****************************************************************************************************/
/* Global Vars */
/****************************************************************************************************/

window.ww; // window width
window.wh; // window width
window.hh;
window.selectedClassName = 'selected'; // the selected class name for menu items
window.menuOpenClassName = 'open'; // the class that defines the open state of the menu
window.fadeInSpeed = 50; // the fade in transition speed
window.fadeOutSpeed = 75; // the fade out transition speed
window.navMouseOutDelay = 600; // the delay before the nav disappears on mouseout
window.mouseOutTimer; // the MouseOut timeout timer 
window.is_responsive = false;
window.lastScrollTop = 0; // used for tracking scroll position and direction
window.nearTop = false;
window.scrollDirection = ""; // default
window.st = window.pageYOffset || document.documentElement.scrollTop;
var $header = $("#header");

/****************************************************************************************************/
/* GSAP Globals */
/****************************************************************************************************/

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
CustomEase.create("letters", ".22,1,.36,1" // cubic-bezier() copied from old site's css
);

CustomEase.create("herooverlay", ".85,0,.15,1" // cubic-bezier() copied from old site's css
);

refreshDimensions();

/****************************************************************************************************/
/* Scrolling */
/****************************************************************************************************/

function refreshScrollData() {
  window.st = window.pageYOffset || document.documentElement.scrollTop;
  window.nearTop = window.st <= 200;
  if (window.st > window.lastScrollTop) {
    window.scrollDirection = "down";
  } else {
    window.scrollDirection = "up";
  }

  // Scroll-to-top link
  if (window.st > 450) {
    $('.scrollToTop').fadeIn();
  } else {
    $('.scrollToTop').fadeOut();
  }
  if (lastScrollTop === 0 || window.st === 0) {
    $header.addClass("top");
  } else {
    $header.removeClass("top");
  }
  if (window.nearTop) {
    $header.addClass("near-top");
  } else {
    $header.removeClass("near-top");
  }

  //window.nearTop = (window.scrollDirection === "up" && window.st <= 200);
  window.lastScrollTop = window.st <= 0 ? 0 : window.st; // needs to be last
}

function refreshDimensions() {
  // update calculated dimensions (to be used on resize events, or anytime a manual refresh is required)
  window.ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  ; //$(window).width(); - CHANGED to avoid reflows.
  window.wh = document.documentElement.clientHeight; //$(window).height(); - CHANGED to avoid reflows.
  window.hh = $(".header").outerHeight() + $(".topHeader").outerHeight(); // $("header").outerHeight();

  // Define your breakpoints (you can adjust these values)
  const breakpoints = {
    small: 500,
    // Small devices (phones)
    medium: 768,
    // Medium devices (tablets)
    large: 1024,
    // Large devices (desktops)
    xlarge: 1200 // Extra large devices (large desktops)
  };

  // Check if we are in Mobile (ie Responsive mode)
  if (window.ww < breakpoints.large) {
    is_responsive = false;
    $("body").addClass("isResponsive");
  } else {
    is_responsive = false;
    $("body").removeClass("isResponsive");
  }

  // padding to match fixed header height
  //if ($header && $header.length) { //  && is_responsive
  //    $("#wrapper").css({ paddingTop: hh + "px" });
  //    $("header").css({ height: hh + "px" });
  //} else {
  //    $("#wrapper").css({ paddingTop: 0 });
  //}

  if (!isSitefinityEditor()) {
    refreshScrollData(); // refresh scroll data just in case...
    refreshForcedWidthContainers();
  }
}

/****************************************************************************************************/
/* Containers */
/****************************************************************************************************/

function refreshScrollbarWidthValue() {
  var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  try {
    scrollbarWidth = getScrollbarWidth();
  } catch {
    console.log("unable to calculate scrollbar width automatically.");
  }
}
function getTopLevelScrollBarWidth() {
  var scrollbarWidth = 0;
  if (document.body.scrollHeight > document.body.clientHeight || document.documentElement.scrollHeight > document.documentElement.clientHeight) {
    scrollbarWidth = getScrollbarWidth();
  }
  return scrollbarWidth;
}

/* Updates the max-width of edge-to-edge containers to account for scrollbars */
function refreshForcedWidthContainers() {
  //var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  //try {
  //    scrollbarWidth = getScrollbarWidth();
  //    console.log({ scrollbarWidth });
  //}
  //catch {
  //    console.log("unable to calculate scrollbar width automatically.");
  //}
  var scrollbarWidth = getTopLevelScrollBarWidth();
  //var width = "calc(100vw - " + scrollbarWidth + "px)";
  //var $forcedWidthContainers = $(".container.edge, .container.force");
  //$forcedWidthContainers.each(function () {
  //    $(this).css({
  //        //width: width,
  //        maxWidth: "100vw"
  //    });
  //});
  //$edgeWidthContainers.each(function () {
  //    $(this).css({
  //        //width: width,
  //        maxWidth: "100vw"
  //    });
  //});
  // ToDo: try doing this with a custom property instead:
  let root = document.documentElement;
  root.style.setProperty('--scrollbar-width', scrollbarWidth + "px");
}
function getScrollbarWidth() {
  //debugger;

  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}
/****************************************************************************************************/
/* Document Ready */
/****************************************************************************************************/

window.addEventListener('DOMContentLoaded', function () {
  $header = $("#header");
  refreshDimensions();
  $(window).trigger('resize');
  setTimeout(refreshDimensions, 2000); // re-run after a few seconds to capture any late layout shifts (from fonts loading or other)
});

/****************************************************************************************************/
/* Scroll Events */
/****************************************************************************************************/

var mainScrollEvent = function () {
  $header = $("#header");
  refreshScrollData();
  $header.removeClass("down up").addClass(window.scrollDirection);
};

// optimized event handler: https://web.dev/uses-passive-event-listeners/
document.addEventListener('scroll', mainScrollEvent, {
  passive: true
});

/****************************************************************************************************/
/* Window Resizing */
/****************************************************************************************************/

$(window).on('resize', function () {
  refreshDimensions();
});

/****************************************************************************************************/
/* Sliders / Carousels */
/****************************************************************************************************/

/* multi-item slider: on mounted (prevent issues with looping, perPage, arrows, etc ) */
function onMountedMultiItemSlider(splide) {
  console.log("multi-item slider mounted!", splide);
  if (!splide.options.fixedWidth && !splide.options.autoWidth) {
    if (splide.options.perPage && splide.Components.Slides.getLength(true) <= splide.options.perPage) {
      //debugger;
      $(splide.root).addClass("noSliderNeeded"); // add a class so we can adjust styling if needed
      splide.options.drag = false;
      splide.options.noDrag = "*"; // I don't think we should need this, however for now it prevents unwanted dragging even when drag is disabled.
      splide.options.arrows = false;
      splide.options.pagination = false;
      splide.options.type = 'slide';
      splide.options.classes.arrows += " hiddenArrows";
      $(splide.Components.Elements.arrows).attr("class", splide.options.classes.arrows); // force our custom HTML arrows to use the reactive Splide classes
      //splide.Components.Arrows.destroy(); // doesn't work ...
      splide.refresh();
    }
  }
}

/* auto-height slider: shared event callbacks */
var autoHeightEvents = {
  mounted: onMountedAutoHeightSlider,
  refresh: onMountedAutoHeightSlider,
  move: onMoveAutoHeightSlider
};

/* updates the slider height during the slider move event */
function onMoveAutoHeightSlider(newIndex, prevIndex, destIndex, splide) {
  var height = $(splide.Components.Elements.slides[newIndex]).outerHeight();
  updateSliderHeight(splide, height);
}
function onMountedAutoHeightSlider(splide) {
  //if (splide.Components.Elements.slides.length <= 1) {
  //    splide.destroy();
  //    $(splide.root).find(".splide__arrows").hide();
  //}
  $(splide.root).find(".splide__list").css({
    alignItems: "flex-start"
  });
  var height = $(splide.Components.Elements.slides[splide.index]).outerHeight();
  updateSliderHeight(splide, height);
  setTimeout(function () {
    updateSliderHeight(splide, height);
  }, 2000);
}
function updateSliderHeight(splide, height) {
  if (splide && height) {
    $(splide.Components.Elements.track).animate({
      height: height + "px"
    }, {
      duration: splide.options.speed
      //complete: function () { }
    });
  }
}

;

/**
 * How to use our splide configs (SIMPLE):
 * 
 * 1. Get your slider HTML onto the page (i.e. from a View or static block). Basic splide classes and markup are required here.
 * 2. Make sure the ".splide" element has a custom data attribute 'data-splide-preset' (e.g. 'data-splide-preset="single"')
 * 3. That's it. The code below will locate your ".splide[data-splide-preset]" element and render it using the specified configuration.
 * 
 */

/*
 Global splide config. Used a base for ALL splide sliders. 
 */
window.globalSplideConfig = {
  type: 'loop'
  //start: 0,
  //perPage: 1,
  //perMove: 1,
  //pagination: true,
  //arrows: false,
  //autoHeight: true,
  //rewind: false,
  //speed: '500',
  //autoplay: true,
  //easing: 'cubic-bezier(.12,.8,.47,.98)',
  //accessibility: true,
  //classes: {
  //    //arrows: 'splide__arrows your-class-arrows',
  //    //arrow: 'splide__arrow your-class-arrow',
  //    prev: 'splide__arrow--prev fas fa-chevron-left',
  //    next: 'splide__arrow--next fas fa-chevron-right',
  //},
  //throttle: 10, // throttle the resize function (default 100 ms)
};

/*
 Slider presets. These get merged with the globalSplideConfig options to configure ALL splide sliders throughout the site.
 */
window.SplideConfigurations = [/* Default configuration */
{
  name: "default",
  //start: 0,
  type: 'loop',
  perPage: 5,
  perMove: 1,
  gap: "0rem",
  updateOnMove: true,
  arrows: true,
  pagination: false,
  breakpoints: {
    1299: {
      perPage: 4
    },
    1024: {
      perPage: 3
    },
    640: {
      perPage: 2
    }
  },
  variants: [{
    // config that inherits/overrides a parent config
    name: "default-no-dots",
    pagination: false
  }],
  on: {
    mounted: onMountedMultiItemSlider,
    beforeMounted: function (splide) {
      console.log("triggered beforeMounted event. Splide: ", splide);
    }
  }
}, /* Fade */
{
  name: "fade",
  type: 'fade',
  start: 0,
  perPage: 1,
  perMove: 1
}, /* Homeslideshow / Hero */
{
  name: "hero",
  type: 'fade',
  rewind: true,
  speed: "2000",
  start: 0,
  perMove: 1,
  autoplay: true
}, /* Single Slide Resources */
{
  name: "single",
  type: 'loop',
  start: 0,
  perPage: 1,
  perMove: 1,
  variants: [{
    name: "single-auto-height",
    autoHeight: true,
    fixedHeight: false,
    on: Object.assign(autoHeightEvents, {// combine shared events with custom ones
      // move: function(){}
    })
  }]
}, /* Double (2-item) sliders  */
{
  name: "double",
  type: 'loop',
  start: 0,
  perPage: 2,
  perMove: 2,
  gap: "2rem",
  breakpoints: {
    640: {
      perPage: 1,
      perMove: 1
    }
  }
}, /* Triple (4-item) sliders  */
{
  name: "triple",
  type: 'loop',
  start: 0,
  perPage: 3,
  perMove: 3,
  gap: "2rem",
  breakpoints: {
    768: {
      perPage: 2,
      perMove: 2
    },
    640: {
      perPage: 1,
      perMove: 1
    }
  }
}, /* Quad (4-item) sliders  */
{
  name: "quad",
  type: 'loop',
  start: 0,
  perPage: 4,
  perMove: 4,
  gap: "2rem",
  breakpoints: {
    1024: {
      perPage: 3,
      perMove: 3
    },
    768: {
      perPage: 2,
      perMove: 2
    },
    640: {
      perPage: 1,
      perMove: 1
    }
  }
}, /* Custom */
{
  name: "custom",
  perPage: 5,
  perMove: 1,
  gap: "0rem",
  breakpoints: {
    1299: {
      perPage: 4
    },
    1024: {
      perPage: 3
    },
    640: {
      perPage: 2
    },
    500: {
      perPage: 1
    }
  }
}, {
  name: "custom2",
  perPage: 4,
  perMove: 1,
  gap: 0,
  breakpoints: {
    1299: {
      perPage: 3
    },
    1024: {
      perPage: 2
    },
    640: {
      perPage: 1
    }
  }
}];

/* Get a splide configration matching a given name */
function getSplideConfiguraion() {
  let splideConfigurationName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  let mergedConfiguration = {};
  for (var configuration of window.SplideConfigurations) {
    if (configuration.name === splideConfigurationName) {
      mergedConfiguration = mergeConfigurations({}, configuration);
      break;
    } else if (configuration.hasOwnProperty("variants") && configuration.variants.length) {
      for (var variant of configuration.variants) {
        if (variant.name === splideConfigurationName) {
          mergedConfiguration = mergeConfigurations(configuration, variant);
          // remove unneeded properties
          delete mergedConfiguration.variants;
          //delete mergedConfiguration.name;
          break;
        }
      }
    }
  }
  mergedConfiguration = mergeConfigurations(window.globalSplideConfig, mergedConfiguration);
  return mergedConfiguration;
}

/* merge two splide configurations intelligently (rather than blindly overwriting each other) */
function mergeConfigurations(config1, config2) {
  let mergedConfiguration = Object.assign({}, config1, config2);

  // merge the "on" callbacks/arrays. this allows configurations to inherit event callbacks (such as 'mounted') from the default configuration (and variants to inherit from their parents)
  if (config1.hasOwnProperty("on") && config2.hasOwnProperty("on")) {
    for (const [eventName, config1Callbacks] of Object.entries(config1.on)) {
      // loop through the config1 on callbacks
      if (typeof config2.on[eventName] !== "undefined") {
        let config2Callbacks = config2.on[eventName] || [];
        mergedConfiguration.on[eventName] = mergeCallbacks(config1Callbacks, config2Callbacks);
      }
    }
  }
  return mergedConfiguration;
}

/* takes two arguments (function or array of functions) and returns a merged, unique array of those functions */
/* primarily used for combining the "on" agruments/callbacks of several splide configurations */
function mergeCallbacks(cbArray1, cbArray2) {
  cbArray1 = Array.isArray(cbArray1) ? cbArray1 : [cbArray1];
  cbArray2 = Array.isArray(cbArray2) ? cbArray2 : [cbArray2];
  return [...new Set([...cbArray1, ...cbArray2])]; // creates a unique merged array (removes duplicate function references)
}

/* Initiate a splide slider using one of our configurations and all of our custom logic. */
function initSplideSlider($selector, configurationName) {
  let $slider = $($selector);
  let configuration = getSplideConfiguraion(configurationName);
  let splide = new Splide($slider[0], configuration);

  /* register custom event callbacks defined in the configuration object */
  if (typeof configuration.on !== "undefined") {
    for (const eventName in configuration.on) {
      /* BEFORE MOUNT EVENT (custom CF event) - allows us to do things prior to initializing a slider */
      if (eventName === "beforeMounted") {
        let beforeMountedCallbacks = Array.isArray(configuration.on[eventName]) ? configuration.on[eventName] : [configuration.on[eventName]];
        /* loop through the beforeMounted callbacks and run them */
        beforeMountedCallbacks.forEach(function (beforeMountedCallback, index) {
          if (typeof beforeMountedCallback === "function") {
            beforeMountedCallback(splide);
          }
        });
        delete configuration.on[eventName]; // remove these non-splide events as they are not needed beyond this point.
        continue;
      }

      /* event binding - allows for mutiple functions to be bound to a single callback. */
      let callbacks = Array.isArray(configuration.on[eventName]) ? configuration.on[eventName] : [configuration.on[eventName]];
      for (const callback of callbacks) {
        if (typeof callback === "function") {
          splide.on(eventName, function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            // this is a closure. we capture the default args, then add our own 
            callback(...args, splide);
          });
        }
      }
    }
  }

  // add it to our list of registered sliders (for potential later use)
  window.splideSliders = window.splideSliders || [];
  window.splideSliders.push({
    el: $slider,
    splide,
    configuration
  });

  //splide.mount({ Grid });
  splide.mount();
}

/* Loop through our widget / view sliders and initiate them using their preset configs */
window.splideSliders = window.splideSliders || [];
$(".splide[data-splide-preset]").not(".is-active").each(function (i, el) {
  let $slider = $(this);
  let configurationName = $slider.attr("data-splide-preset");
  initSplideSlider($slider, configurationName);
});

/****************************************************************************************************/
/* Search Box Non-Modal Toggle */
/****************************************************************************************************/

$(function () {
  $("a.searchExpand").on("click", function () {
    $(".searchHiddenWrapper").slideToggle();
  });
  $("button.searchCollapse").on("click", function () {
    $(".searchHiddenWrapper").slideToggle();
  });
});

/****************************************************************************************************/
/* Forms / Autofill */
/****************************************************************************************************/

// SEARCH BOX - PLACEHOLDER TEXT
$('.search input[type="text"]').attr("placeholder", "How Can We Help You?");

// Fix for Chrome Form Autofill for our contact form
$(".contactForm input[name*=Name]").attr('autocomplete', 'name');
$(".contactForm input[name*=Email]").attr('autocomplete', 'email');
$(".contactForm input[name*=Phone]").attr('autocomplete', 'tel');
// Or you could turn it off
//$('form').attr('autocomplete', 'off');

/****************************************************************************************************/
/* Misc */
/****************************************************************************************************/

// check if we're running inside the SF Page editor
function isSitefinityEditor() {
  return $("body").hasClass("sfPageEditor") || typeof sitefinity === "object";
}

// Clickable items (e.g. a clickable article card with nested links)
$(document).on("click", ".clickable", function (event) {
  var $this = $(this);
  if (!isSitefinityEditor()) {
    // If there's not data-url, then find the first child el with an href and use that
    var itemUrl = "";
    var target = "_self"; // default

    // allow links within to work
    if ($(event.target).is('a[href]')) {
      return;
    }

    // First check for data atts. If none, use the first child link
    else if (typeof $this.data("url") !== 'undefined' && $this.data("url").length) {
      itemUrl = $this.data("url");
      if (typeof $this.data("target") !== 'undefined' && $this.data("target").length) {
        target = $this.data("target");
      }
    } else {
      var $firstLinkFound = $this.find("a[href]").first();
      itemUrl = $firstLinkFound.attr("href");
      target = $firstLinkFound.attr("target") ? $firstLinkFound.attr("target") : target;
    }
    window.open(itemUrl, target);
  }
});

// Play Audio 
window.addEventListener('DOMContentLoaded', function () {
  $(document).on("click", ".audioFile a", function () {
    playAudio($(this).attr("data-audioid"));
    return false;
  }).on("keypress", ".audioFile a", function (e) {
    if (e.which === 13) {
      // enter key code
      playAudio($(this).attr("data-audioid"));
      return false;
    }
  });

  // Play Audio
  function playAudio($audioid) {
    var audioFile = $('#' + $audioid).addClass("playing").get(0).play();
  }
});

///Copyright Script
var publishedDate = 2022;
var year = $('.copyrightYear');
if (year.html() == publishedDate) {
  year.html(publishedDate);
} else {
  year.html(publishedDate + '-' + new Date().getFullYear());
}
document.addEventListener('DOMContentLoaded', function () {
  //callback function: simply adds a class when the element is in the viewport
  function observerCallback(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('inViewport');
      }
    });
  }

  //only activate when an element is 20% visible
  let observerOptions = {
    threshold: 0.05
  };

  //create an intersection observer to watch
  var observer = new IntersectionObserver(observerCallback, observerOptions);
  let wrapperTarget = '.wrapper:not(.sfPageEditor .wrapper)'; //stop adding inViewPort to templates during editing
  if (!!window.IntersectionObserver) {
    //check if browser supports it, 
    document.querySelectorAll(wrapperTarget).forEach(i => {
      if (i) {
        observer.observe(i);
      }
    });
  } else {
    // if not, unhide everything
    document.querySelectorAll(wrapperTarget).forEach(i => {
      if (i) {
        i.classList.remove('wrapper');
      }
    });
  }

  ////make jumpMenu stick to the top of the
  //const el = document.querySelector(".jumpMenuWrapper")
  //const observer2 = new IntersectionObserver(
  //    ([entry]) => entry.target.querySelector(".stickyWrapper").classList.toggle("stuck", entry.intersectionRatio < 1),
  //    { threshold: [1] }
  //);
  //observer2.observe(el);
});

//Kendo treeview to create accordions in layouts
window.addEventListener('DOMContentLoaded', function () {
  var $treeViewAccordion = $(".accordionGroup");
  $treeViewAccordion.kendoTreeView({
    expandMode: "multiple"
  });
});
window.addEventListener('DOMContentLoaded', function () {
  var $treeViewCareers = $(".listView.careers");
  $treeViewCareers.kendoTreeView({
    expandMode: "multiple"
  });
});

// Clear Local Storage querydata and filters if not on a detail or filtered content page
window.addEventListener('DOMContentLoaded', function () {
  var detailPage = document.querySelector(".detailPage");
  var filtersContainer = document.querySelector(".filteredContent");
  var isLocalStorageDisabled = false;
  var isPageReload = performance.getEntriesByType("navigation")[0].type === "reload";
  if (filtersContainer) {
    isLocalStorageDisabled = filtersContainer.dataset.localStorageDisabled === "true" ? true : false;
  }
  var canClearLocalStorage = !detailPage && !filtersContainer || isLocalStorageDisabled || isPageReload;
  if (canClearLocalStorage || isPageReload) {
    localStorage.removeItem("cf_filteredcontentscrollto");
    localStorage.removeItem("cf_filteredcontent");
    localStorage.removeItem("cf_filteredcontentsearchparams");
    if (isPageReload && filtersContainer) {
      var dropdownLists = document.querySelectorAll(".k-dropdown select");
      if (dropdownLists) {
        for (let i = 0; i < dropdownLists.length; i++) {
          dropdownLists[i].options[0].selected = true;
          dropdownLists[i].previousSibling.querySelector(".k-input").innerText = dropdownLists[i].options[0].innerText;
        }
      }

      //document.querySelector(".keywordSearch").value = "";
    }
  }
});
/* Toggle Filters Groups on Checkbox FilteredContent */
document.addEventListener('click', function (event) {
  if (event.target.classList.contains('filterToggle')) {
    // Prevent Default Action
    event.preventDefault();
    const toggleFilterClicked = event.target;
    const toggleFilterContentToControl = toggleFilterClicked.nextElementSibling;
    if (toggleFilterClicked.classList.contains('active')) {
      /* already has 'active' the class remove it */
      toggleFilterClicked.classList.remove('active');
      toggleFilterContentToControl.classList.remove('active');
    } else {
      /* add the 'active' class */
      toggleFilterClicked.classList.add('active');
      toggleFilterContentToControl.classList.add('active');
    }
  }
}, false);
jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, {
      passive: !ns.includes("noPreventDefault")
    });
  }
};
jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchmove", handle, {
      passive: !ns.includes("noPreventDefault")
    });
  }
};
jQuery.event.special.wheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("wheel", handle, {
      passive: true
    });
  }
};
jQuery.event.special.mousewheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("mousewheel", handle, {
      passive: true
    });
  }
};

/**********************************************************************************************************************/
/* region Mobile Menu */
/**********************************************************************************************************************/

if (!isSitefinityEditor()) {
  //$("#mobileMenu").popup({
  //    scrolllock: true,
  //    blur: false, // if true, clicking outside the modal will close it (disabled to prevent user accidentally closing)
  //    //focuselement: $(this).find("input[type=search]"), // which element to focus after modal open
  //    //openelement: ".searchModal-1_open",
  //    //beforeopen: function (modalEl, $openButton) { // find the background overlay and add some special classes for our specific styling needs (if necessary)
  //    //    $("#" + $(modalEl).attr("id") + "_background").addClass("searchModalBackground open");
  //    //    // Make sure the header appears above the popup wrapper.
  //    //    var modalZIndex = $(modalEl).closest(".popup_wrapper").css("z-index");
  //    //    $("#header").css({ zIndex: modalZIndex + 1 });
  //    //},
  //    //onclose: function (modalEl, $openButton) { // remove any custom "modal open" classes which we added
  //    //    $("#" + $(modalEl).attr("id") + "_background").removeClass("open");
  //    //}
  //});

  var $mobileMenu = $("#mobileMenu");
  var menuPopup = $mobileMenu.popup({
    transition: false,
    scrolllock: true,
    blur: false,
    onopen: function () {
      //console.log($mobileMenu);
      $(".hamburger").addClass("open");
      //$("#mobileMenu_wrapper")
    },

    onclose: function () {
      $(".hamburger").removeClass("open");
    }
  });
  //console.log(menuPopup);

  $(".hamburger").on("click", function () {
    $mobileMenu.popup("toggle");
  });
}